<template>
    <v-container justify-center class="multiDesk2" style="padding-top:0px">
        <v-card flat class="multiDesk">
            <v-card-text>
                <v-layout row wrap>
                   <v-flex xs12 class="text-xs-center mb-5">
                        <img cover center width="128px" :src="logoImage" />
                    </v-flex>
                    <v-flex xs12 class="companyText text-xs-center">
                        Please choose the company
                    </v-flex>
                </v-layout>
                <v-container justify-center v-if="denyLogin" class="companyText red--text darken-3">
                    You don't have access to the portal. Please contact your administrator
                </v-container>
                <v-container justify-center  v-if="multipleCompany.length>1" :style="multipleCompany.length<=2 ? 'width:40%' : 
                                                     multipleCompany.length<=3 ? 'width:65%' :
                                                     multipleCompany.length<=4 ? 'width:85%' :
                                                     'width:100%'"
                >
                    <v-layout row wrap>
                    <template v-for="company in multipleCompany">
                        <v-flex pr-2 mr-0 :xs6="multipleCompany.length<=2"
                                     :xs3="multipleCompany.length<=3"
                                     :xs4="multipleCompany<=4" >
                        <v-card  class="companyCard2"  style="background:white" flat>                    
                        <v-card-text style="cursor: pointer;min-height: 110px;"  @click="setCompany(company)">
                        <v-img  class="logo"  height="128px" width="128px" style="margin:0 auto" :style="company.logo ? 'margin-top: 20%;' : ''" :src="company.logo ? company.logo : teamIcon" center cover/>
                        </v-card-text>
                        </v-card>
                        <br/>
                        <p class="body-2 text-xs-center">
                        {{company.name}}
                        </p>
                        </v-flex>
                    </template>
                </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>    
</template>
<script>
import FirebaseModel from  '../FirebaseService.js'

export default {
    data() {
        return {
            logoImage:require('@/assets/gna-logo.png'),
            teamIcon:require('@/assets/team-icon.svg'),
            multipleCompany:[],
            host:window.location.host,
            denyLogin:false,
            parts:window.location.host.split('.')
        }
    },
    mounted:async function() {
    if(this.$route.query.token) {
             this.authenticateToken()
        } else {
            this.redirectToSso()
        }
    },
    methods: {
        setCompany($company) {
            this.redirectToApp($company.team,$company.token)
        },
        redirectToSso() {
             let $host = window.location.host;
             window.location=process.env.VUE_APP_ONEAPP_DOMAIN   
        },
        async authenticateToken() {
            let $response = await FirebaseModel.firebaseAuth({token:this.$route.query.token})
            if($response.data.length==1) {
                this.redirectToApp($response.data[0].team ,$response.data[0].token  )
            }  else if($response.data.length>1) {
                this.multipleCompany=$response.data
                this.denyLogin =false
            } else {
                this.multipleCompany=[]
                this.denyLogin =true
            }
        },
        redirectToApp($team,$token) {
            if(this.host.indexOf('localhost')>=0) {
                this.$router.push("/autoLogin?loginToken="+$token)
            } else {
                // window.location = 'https://'+ $team +'.'+ 
                // this.parts[this.parts.length-2] +'.'+
                // this.parts[this.parts.length-1]+"/autoLogin?loginToken="+$token
                this.$router.push(`/autoLogin?loginToken=${$token}&team=${$team}`)
            }
        }
    }
}
</script>
<style >
.companyCard2 {
    position: relative;
    height: 162px;
    background:"transparent"
}
.companyText {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 0.03em;
}
.logo:hover {
    border:2px solid blue;
    border-radius:15px;
}
.multiDesk {
    position: absolute;
    width: 100%;
    height: 100vh;
    left: 0%;
    background-color:#F7F7F7 !important;
}
</style>